import { createApp } from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import Toaster from "@meforma/vue-toaster";

/*
import Vue from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";

const options = {
  transition: "Vue-Toastification__bounce",
  maxToasts: 20,
  newestOnTop: true
};

Vue.use(Toast, options);

Vue.config.productionTip = false;

new Vue({
  vuetify,
  Toast,
  render: h => h(App)
}).$mount("#app");
*/

createApp(App).use(Toaster).use(vuetify).mount("#app");
